import React from 'react'
import logoImage from '../img/logo_2.svg'
import { AiFillFacebook, AiFillLinkedin } from 'react-icons/ai'
import { MdOutlineNavigateNext } from 'react-icons/md'
const Footer = () => {
    return (
        <div className='bg-[#67bdb7] xl:px-[15rem] px-5'>
            <div className=' grid xl:grid-cols-4'>
                <div className=' xl:col-span-3'>
                    <img src={logoImage} className=" w-[200px]" alt="" />
                </div>

                <div className='flex xl:justify-end items-center'>
                    <AiFillFacebook className=' text-white cursor-pointer' size={30} />
                    <AiFillLinkedin className='text-white cursor-pointer' size={30} />
                </div>

            </div>
            <div className='grid xl:grid-cols-5 mb-10 mt-5 text-white'>
                <div className=' xl:col-span-2'>
                    <p className=' text-2xl font-bold'>+66(0)1-234-5678</p>
                    <p className=' mt-3 font-thin '>We are open: Monday – Friday</p>
                    <p className=' font-thin'>9 am – 6 pm (UTC+7)</p>
                    <button className='mt-5 min-w-[120px] h-[45px] text-center rounded-full text-white  border-white border-[2px] text-[16px] transition delay-100 ease-in hover:bg-white hover:text-black'>Email us</button>
                </div>
                <div className=' '>
                    <p className=' text-2xl font-bold'>Services</p>
                    <p className=' mt-3 font-thin cursor-pointer hover:text-gray-200'>Formation</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Governance</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Accounting & tax</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>HR outsourcing</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Immigration</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Legal</p>
                </div>
                <div>
                    <h1 className=' text-2xl font-bold'>Company</h1>
                    <p className=' mt-3 font-thin cursor-pointer hover:text-gray-200'>About us</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Contact us</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>News & insights</p>
                </div>
                <div>
                    <h1 className=' text-2xl font-bold'>Resources</h1>
                    <p className=' mt-3 font-thin cursor-pointer hover:text-gray-200'>Formation guides</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Governance guides</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Accounting guides</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>HR guides</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Immigration guides</p>
                    <p className=' mt-2 font-thin cursor-pointer hover:text-gray-200'>Legal guides</p>
                </div>
            </div>
            <hr className=' opacity-40' />
            <div className=' grid xl:grid-cols-4 text-white py-10'>
                <div className=' xl:col-span-3 flex items-center'>
                    <p className=' text-white'>© Accept Me 2022 | <span className=' font-thin hover:underline cursor-pointer'>Privacy policy</span></p>

                </div>

                <div className='flex xl:justify-end justify-start items-center mt-3'>
                    <img src="https://img.freepik.com/free-vector/illustration-thailand-flag_53876-27145.jpg" alt="Thailand" className='w-[30px] h-[30px] rounded-full object-fill object-center' />
                    <p className='ml-3 cursor-pointer'>Change location </p>
                    <MdOutlineNavigateNext className=' cursor-pointer rotate-90 text-white ml-1' size={20} />
                </div>

            </div>
        </div>
    )
}

export default Footer